import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'empathy-randomized-questions-setting',
  templateUrl: 'randomized-questions-setting.component.html',
  styleUrls: ['./randomized-questions-setting.component.scss', './_randomized-questions-settings-theme.component.scss']
})
export class RandomizedQuestionsSettingComponent {
  @Input() activeQuestion: FormGroup;
  @Input() showBorder = true;
}
